import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { ThemeProvider } from '@mui/material/styles';

import { PageSpinner } from '@atoms';

import MUITheme from './MUI/MUIThemeConfig';
import LocalizationProvider from './providers/LocalizationProvider';
import MainRoute from './routes';

import '@styles/App.scss';

import StylesProvider from './context/StylesContext';
import { persistor, store } from './store';

import { CookieProvider } from './hooks/useCookies';

function App() {
  return (
    <StylesProvider>
      <ThemeProvider theme={MUITheme}>
        <LocalizationProvider>
          <Suspense fallback={<PageSpinner />}>
            <Provider store={store}>
              <PersistGate loading={<PageSpinner />} persistor={persistor}>
                <CookieProvider>
                  <MainRoute />
                </CookieProvider>
              </PersistGate>
            </Provider>
          </Suspense>
        </LocalizationProvider>
      </ThemeProvider>
    </StylesProvider>
  );
}

export default App;
